import { Fragment } from 'react'
import { Text } from '@chakra-ui/react'
import { NextSeo } from 'next-seo'

import TermAndPrivacyLayout from '@/features/TermsAndPrivacy/components/TermAndPrivacyLayout'
import { renderTemplate } from '@/features/TermsAndPrivacy/helpers'

import NavigationBar from '@/components/organisms/NavigationBar'
import { Footer } from '@/components/organisms/Footer'

function PrivacyPolicy(): React.ReactElement {
  const type = 'privacy'
  return (
    <Fragment>
      <NextSeo title="Privacy Policy" />
      <NavigationBar />
      <TermAndPrivacyLayout>
        <Text as="h1">นโยบายความเป็นส่วนตัว</Text>
        <Text>
          บริษัท เดต้า ว้าว จำกัด (“บริษัท”หรือ”เรา”)
          ตระหนักถึงความสำคัญในการรักษาความเป็นส่วนตัวและความปลอดภัยของข้อมูลส่วนบุคคลของผู้ใช้งาน(“คุณ”)
          บนเว็บไซต์ (www.learnpdpa.com) รวมถึงเว็บไซต์ ฟีเจอร์ เทคโนโลยี
          เนื้อหา และผลิตภัณฑ์ต่าง ๆ ที่เกี่ยวข้อง (ซึ่งต่อไปนี้จะเรียกรวมกันว่า
          “แพลตฟอร์ม”) ดังนั้น
          บริษัทจึงได้ประกาศนโยบายความเป็นส่วนตัวฉบับนี้ขึ้นเพื่อให้คุณได้รับทราบถึงวิธีการที่บริษัทเก็บรวบรวม
          ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ
          ตลอดจนสิทธิตามกฎหมายของคุณที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
          ซึ่งเป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
        </Text>
        {renderTemplate(type)}
        <br />
        <hr />
        <br />
        <Text id="end-content" sx={{ fontWeight: 'medium' }}>
          นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ 3 ตุลาคม 2565
        </Text>
      </TermAndPrivacyLayout>
      <Footer />
    </Fragment>
  )
}

export default PrivacyPolicy
